import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const DISABLE_ROUTE = {
    typeModal: TYPE_MODAL.NOTIFICATION,
    title: '¿Está seguro que desea deshabilitar las rutas?',
    valueButton: 'Guardar',
    color: CONFIRM_COLOR.WARN,
    iconSVG: CONFIRM_ICONS.SAVE
  };
